import svgUrl from "ni:svgr;u5Q5c3ohd3cOmZX6UWxaeBunUUjv9m82FnSAPn9aGOg";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const BlankTableMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><rect width={20} height={18} x={2} y={3} fill="var(--tbl--colors--icons--transformation--primary)" opacity={0.1} rx={2} /><path fill="var(--tbl--colors--icons--transformation--primary)" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1H2V5Z" /><path fill="var(--tbl--colors--icons--transformation--tertiary)" fillRule="evenodd" d="M13 11H6v4h7v-4Zm-7 5v5H4a2 2 0 0 1-2-2V6h4v4h7V6h1v4h8v1h-8v4h8v1h-8v5h-1v-5H6Z" clipRule="evenodd" /></svg>;
const Memo = memo(BlankTableMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "BlankTableMIcon";
}